export default __webpack_public_path__ + "33543c5cc5d88f5695dd08c87d280dfd.woff2";